import { useWalletsMe } from '@/api/wallets';
import { RootState } from '@/lib/store';
import { Bet } from '@/models/bet';
import { Nullable } from '@starsoft/common/interfaces';
import { Decimal } from '@starsoft/common/services/Decimal';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useBetPayout(bet: Nullable<Bet>, multiplier: Decimal) {
  const amount = useSelector(
    (state: RootState) => state.gamePreferences.amount,
  );
  const { wallet } = useWalletsMe();

  const decimalAmount = useMemo(
    () =>
      new Decimal(amount, {
        scale: wallet?.currentAccount?.coin?.decimals ?? 0,
      }),
    [amount, wallet?.currentAccount?.coin?.decimals],
  );

  function getPayout(): number {
    try {
      let payout: Decimal;

      if (!!bet) {
        payout = bet?.amount
          ?.copyWith({ options: { scale: 4 } })
          .multiply(multiplier)
          .copyWith({
            options: {
              scale:
                bet?.coin?.decimals ?? wallet?.currentAccount?.coin?.decimals,
            },
          });
      } else {
        payout = decimalAmount
          ?.copyWith({ options: { scale: 4 } })
          .multiply(multiplier)
          .copyWith({
            options: {
              scale:
                bet?.coin?.decimals ?? wallet?.currentAccount?.coin?.decimals,
            },
          });
      }

      return payout.toNumber();
    } catch (error) {
      return 0;
    }
  }

  return useMemo(getPayout, [
    bet,
    multiplier,
    decimalAmount,
    wallet?.currentAccount?.coin?.decimals,
  ]);
}
